module.exports = __webpack_public_path__ + "static/img/login_warning.2684ef10.png";